export default {
	list: 'BusinessEventRunningTotal',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		PartnerID: {
			class: "lookup",
			dataName: 'Partner/PartnerID',
			type: 'number',
			title: 'Partner ID',
			width: 100,
			hidden: false,
			readOnly: true
		},
		PartnerFullName: {
			class: "lookup",
			dataName: 'Partner/FullName',
			type: 'string',
			title: 'PartnerFullName',
			width: 100,
			hidden: false,
			readOnly: true
		},
		PartnerTaxStatus: {
			class: "lookup",
			dataName: 'Partner/TaxStatus',
			type: 'string',
			title: 'Tax Status',
			width: 120,
			hidden: true
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'number',
			title: 'ProgramTitle',
			width: 100,
			hidden: true,
			readOnly: true
		},
		PartnerId: {
			class: "lookup",
			dataName: 'PartnerId',
			type: 'number',
			title: 'PartnerId',
			width: 100,
			hidden: false,
			readOnly: false
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'ProgramId',
			width: 100,
			hidden: true,
			readOnly: false
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'UnitClass',
			width: 100,
			hidden: false,
			readOnly: false
		},
		UnitPool: {
			class: 'value',
			dataName: 'UnitPool',
			type: 'string',
			title: 'UnitPool',
			width: 100,
			hidden: false,
			readOnly: false
		},
		UnitType: {
			class: 'value',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 100,
			hidden: false,
			readOnly: false
		},
				Unit: {
			class: 'value',
			dataName: 'Unit',
			type: 'string',
			title: 'Unit',
			width: 100,
			hidden: false,
			readOnly: false,
			template: '#=kendo.format("{0:n2}", Unit )#',
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'Business Event',
			width: 100,
			hidden: false,
			readOnly: false
		},
		VestingType: {
			class: 'choice',
			dataName: 'VestingType',
			type: 'string',
			title: 'Vesting Type',
			width: 150,
			hidden: false,
			readOnly: false
		},
	}
}